import React from "react";
import { useSelector } from "react-redux";
import Header from "./components/Header";
import InputData from "./components/InputData";
import PreviewData from "./components/PreviewData";

const App = () => {
  const tickets = useSelector((state) => state.tickets);

  return (
    <>
      <Header />
      <section>
        {/* Input Data */}
        <InputData />

        {/* Preview Data */}
        {tickets.length > 0 && <PreviewData />}
      </section>
    </>
  );
};

export default App;
